(function () {
  'use strict';

  var selectorId = 'etranslate-language_currency-dropdown-selector-theme2';
  var slotId = 'relx-etranslate-nav-slot';
  var desktopQuery = window.matchMedia('(min-width: 1025px)');
  var selector = null;
  var originalParent = null;
  var originalNextSibling = null;
  var updateQueued = false;

  function ensureSlot() {
    var slot = document.getElementById(slotId);
    if (slot) return slot;

    var navIcons = document.querySelector('.t4s-section-header .t4s-site-nav__icons');
    if (!navIcons) return null;

    slot = document.createElement('div');
    slot.id = slotId;
    slot.setAttribute('aria-label', 'Language and currency selector');

    var cart = navIcons.querySelector('.t4s-site-nav__cart');
    if (cart && cart.nextSibling) {
      navIcons.insertBefore(slot, cart.nextSibling);
    } else {
      navIcons.appendChild(slot);
    }

    return slot;
  }

  function findSelector() {
    var current = document.getElementById(selectorId);

    if (!current) {
      selector = null;
      return null;
    }

    if (current !== selector) {
      selector = current;
      if (selector.parentNode && selector.parentNode.id !== slotId) {
        originalParent = selector.parentNode;
        originalNextSibling = selector.nextSibling;
      }
    }

    return selector;
  }

  function placeSelector() {
    updateQueued = false;
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var currentSelector = findSelector();
    var slot = ensureSlot();
    if (!currentSelector || !slot) return;

    if (desktopQuery.matches) {
      if (currentSelector.parentNode !== slot) {
        slot.appendChild(currentSelector);
      }
      currentSelector.classList.add('relx-etranslate-in-nav');
    } else {
      if (currentSelector.parentNode === slot && originalParent && originalParent.isConnected) {
        var referenceNode = originalNextSibling && originalNextSibling.parentNode === originalParent
          ? originalNextSibling
          : null;
        originalParent.insertBefore(currentSelector, referenceNode);
      }
      currentSelector.classList.remove('relx-etranslate-in-nav');
    }
  }

  function queuePlacement() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(placeSelector);
  }

  function start() {
    var observer = new MutationObserver(queuePlacement);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    placeSelector();

    /* ETranslate may replace its selector shortly after its initial render. */
    var attempts = 0;
    var settleTimer = window.setInterval(function () {
      placeSelector();
      attempts += 1;
      if (attempts >= 20) window.clearInterval(settleTimer);
    }, 250);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(placeSelector, 120);
    });

    document.addEventListener('shopify:section:load', queuePlacement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
